<!-- show Ship To details -->
<ng-container *ngIf="isShipTo; else billToDetails">
  <div class="info-group">
    <div class="label">{{ 'dealer.shippingName' | cxTranslate }}</div>
    <app-tooltip-text
      class="value cmp-name"
      [tooltipContent]="list.addressName"
      [content]="list.addressName"
      placement="bottom"
      [closeOnRotate]="true"
    ></app-tooltip-text>
  </div>
  <div class="info-group">
    <div class="label">{{ 'dealer.shippingId' | cxTranslate }}</div>
    <div class="value">{{ list.addressId }}</div>
  </div>
  <div class="info-group address">
    <div class="label">{{ 'dealer.shippingAddress' | cxTranslate }}</div>
    <app-tooltip-text
      class="value address-description"
      [tooltipContent]="list.formattedAddress"
      [content]="list.formattedAddress"
      placement="bottom"
      [closeOnRotate]="true"
    ></app-tooltip-text>
  </div>
</ng-container>

<!-- show Bill To / B2B Unit details (default) -->
<ng-template #billToDetails>
  <div class="info-group company">
    <div class="label">{{ 'dealer.company' | cxTranslate }}</div>
    <app-tooltip-text
      class="value cmp-name"
      [tooltipContent]="list.name"
      [content]="list.name"
      placement="bottom"
      [closeOnRotate]="true"
    ></app-tooltip-text>
  </div>
  <div class="info-group customer">
    <div class="label">{{ 'dealer.customer' | cxTranslate }}</div>
    <div class="value">{{ list.uid }}</div>
  </div>
  <div class="info-group address">
    <div class="label">{{ 'dealer.address' | cxTranslate }}</div>
    <app-tooltip-text
      class="value address-description"
      [tooltipContent]="list.addresses ? list.addresses[0].formattedAddress : ''"
      [content]="list.addresses ? list.addresses[0].formattedAddress : ''"
      placement="bottom"
      [closeOnRotate]="true"
    ></app-tooltip-text>
  </div>
</ng-template>
